import Cookies from "js-cookie";
import HCLDX from "@system/config/hcldx";
import getSymbolFromCurrency from "currency-symbol-map/currency-symbol-map";
import Helper from "./Helper";
import Constants from "src/helper/Constants";
import liveAuth from "./liveAuth";
import { isNumber } from "underscore";
import store from "src/storeWire";
import { system_notification } from "src/store/slice/system";
const { userInfoKey, speedBoats, siteUser, PriceType } = Constants

class System {

  static avUserInfoData = {
    speedBoatAbbr: this.getCoockieObjVal(userInfoKey.SPEEDBOAT),
    speedBoatName: this.getCoockieObjVal(userInfoKey.SPEEDBOATNAME),
    speedBoatNameLower: Helper.toLowerCase(this.getCoockieObjVal(userInfoKey.SPEEDBOATNAME)),
    userName: this.getCoockieObjVal(userInfoKey.USERNAME),
    accountNumber: this.getCoockieObjVal(userInfoKey.ACCOUNTNUMBER),
    email: this.getCoockieObjVal(userInfoKey.EMAIL),
    accountName: this.getCoockieObjVal(userInfoKey.ACCOUNTNAME),
    roles: this.getCoockieObjVal(userInfoKey.ROLES),
    salesOrg: this.getCoockieObjVal(userInfoKey.SALESORG),
    orderBlock: this.getCoockieObjVal(userInfoKey.ORDERBLOCK),
    currentUser: liveAuth.check() ? (this.getCoockieObjVal(userInfoKey.ACCOUNTNUMBER) ? siteUser.CORE : siteUser.WEB) : siteUser.GUEST,
    defaultShipTo: this.getCoockieObjVal(userInfoKey.DEFAULTSHIPTO),
    currentShipTo: this.getCoockieObjVal(userInfoKey.CURRENTSHIPTO),
  };

  static getCoockieObjVal(key) {
    const avUserInfo = liveAuth.getAvUserInfo() ? liveAuth.getAvUserInfo() : { "firstName": null, "lastName": null, "phoneNumber": null, "speedboat": "G", "userID": null, "email": null }
    let value = "";

    switch (key) {
      case userInfoKey.USERNAME:
        value = avUserInfo.firstName ? avUserInfo.firstName + ' ' + avUserInfo.lastName : "";
        break;
      case userInfoKey.SPEEDBOATNAME:
        value = speedBoats.AMERICAS
        break;
      case userInfoKey.SPEEDBOAT:
        value = avUserInfo[key] ? avUserInfo[key] : 'G';
        break;
      default:
        if (key === userInfoKey.BILLCOUNTRYCODE || key === userInfoKey.ACCOUNTNAME || key === userInfoKey.ACCOUNTNUMBER || key === userInfoKey.ROLES || key === userInfoKey.SALESORG || key === userInfoKey.ORDERBLOCK || key === userInfoKey.CREDITRISK || key === userInfoKey.DEFAULTSHIPTO) {
          value = avUserInfo?.account && avUserInfo?.account[key] !== undefined ? avUserInfo.account[key] : '';
        } else {
          value = avUserInfo[key] ? avUserInfo[key] : '';
        }
        break;
    }

    return value;
  }

  static getParams(url = window.location) {
    const params = {};
    new URL(url).searchParams.forEach(function (val, key) {
      if (params[key]) {
        if (!Array.isArray(params[key])) {
          params[key] = [params[key]];
        }
        params[key].push(val);
      } else {
        params[key] = val;
      }
    });
    return params;
  }

  static storageName = {
    // session Storage
    QUOTE_CART_ACTIVE_SESSION_SPEEDBOAT: 'QUOTE_CART_ACTIVE_SESSION' + '__' + this.avUserInfoData.speedBoatNameLower,
    QUOTE_CART_ACTIVE_SESSION: 'QUOTE_CART_ACTIVE_SESSION',
    SUCCESS_PAGE: "SUCCESS_PAGE",

    CART_ID: "CART_ID",

    // local Storage
    HCLDX_LOCALHOST_ACTIVATE: "HCLDX_LOCALHOST_ACTIVATE", // not set anywhere only get
    UNIVERSAL_SEARCH_PARAM: "UNIVERSAL_SEARCH_PARAM",
    FLASH_MESSAGE: "FLASH_MESSAGE",
    FLASH_MESSAGE_REMATCH: "FLASH_MESSAGE_REMATCH",
    BOM_UPLOAD_FILE: "BOM_UPLOAD_FILE",
    CART: "CART" + this.avUserInfoData.speedBoatAbbr,
    CART_PRODUCT_DATA: "CART_PRODUCT_DATA",
    PRODUCT_COMPARE: "PRODUCT_COMPARE",
    PRODUCT_COMPARE_API: 'PRODUCT_COMPARE_API__' + this.avUserInfoData.speedBoatNameLower,
    PRODUCT_LISTING_FILTER_BOX_SELECTION: 'ProductListingFilterBoxSelection__' + this.avUserInfoData.speedBoatNameLower,
    PRODUCT_LISTING_SETTINGS: 'PRODUCT_LISTING_SETTINGS',
    ACCOUNT_LINK_SUCCESS_MESSAGE: 'ACCOUNT_LINK_SUCCESS_MESSAGE',
    PRODUCT_LISTING_VIEW: 'PRODUCT_LISTING_VIEW',
    GUEST_SESSION_ID: "GUEST_SESSION_ID",
    GUEST_BOM_ID: "GUEST_BOM_ID",
    ORDER_PAGE_COUNT: "ORDER_PAGE_COUNT",
    ORDER_PAGE_TOKEN: "ORDER_PAGE_TOKEN",
    PAYMENT_ERROR: "PAYMENT_ERROR",
    ORDER_FEEDBACK: "ORDER_FEEDBACK",
    ANALYTICS_EVENT: "adobeEventType",

    // cockie
    CART_COUNT: "CART_COUNT"

  };

  static getBaseUrl() {
    return this.getUserUrl();
  }

  static getBOMUrl() {
    return process.env.REACT_APP_API_BOM;
  }

  static getDesignHubUrl() {
    return process.env.REACT_APP_API_DESIGN_HUB;
  }

  static getApplicationUrl() {
    return process.env.REACT_APP_API_APPLICATION;
  }

  static getCartUrl() {
    return process.env.REACT_APP_API_CART;
  }

  static getInventoryUrl() {
    return process.env.REACT_APP_API_INVENTORY;
  }

  static getPriceUrl() {
    return process.env.REACT_APP_API_PRICE;
  }

  static getProductUrl() {
    return process.env.REACT_APP_API_PRODUCT;
  }

  static getUserUrl() {
    return process.env.REACT_APP_API_USER;
  }

  static getProfileUrl() {
    return process.env.REACT_APP_API_USER;
  }


  static getOrderUrl() {
    return process.env.REACT_APP_API_ORDER;
  }

  static getReportErrorUrl() {
    return process.env.REACT_APP_API_REPORT_ERROR;
  }

  static getAdminConsoleUrl() {
    return process.env.REACT_APP_API_ADMIN_CONSOLE;
  }

  static redirectToNewark(searchTerm) {
    return `https://www.newark.com/search?CMP=AMER-AVNET-NORESULTS-SEARCH-NEWARK&st=${searchTerm}`

  }

  static getTariffInfoUrl() {
    // return `https://www.avnet.com/wps/portal/us/resources/tariff-information/`;
    return HCLDX.get_REACT_APP_HCL_DX_BASE_URL() + 'americas/resources/tariff-information/';
  }

  static getUSTRUrl() {
    return `https://ustr.gov/`;
  }

  static popup(popup_name, data = []) {
    store.dispatch(system_notification({
      name: popup_name,
      data: data,
    }));
  }


  static getHomepageUrl() {
    return HCLDX.baseURL() + '/';
  }

  static getLoginPageUrl(isAuthAccLess = false) {
    if (isAuthAccLess) {
      const speedboatName = this.avUserInfoData.speedBoatName
      const URL = speedboatName === speedBoats.AMERICAS ?
        "/resources/forms/linking-account-forms/" : "/resources/forms/request-account/"

      return this.getRedirectionURL(URL);
    }
    return this.getRedirectionURL("/authenticate/login/");
  }

  static setWindow_avUserInfo_cookie_name() { // need to update based on dx cookie name
    let selectedCurrency = Cookies.get("selectedCurrencyAmericas")
    if (selectedCurrency) {
      window.mct = selectedCurrency;
      window.mcs = getSymbolFromCurrency(window.mct);
    }

  }

  static getHelpPageUrl() {
    return 'https://www.avnet.com/wps/portal/us/about-avnet/help/'
  }

  static getPreviousPageUrl() {
    let _url = "";
    const baseUrl = HCLDX.get_REACT_APP_HCL_DX_BASE_URL();
    const sBoat = this.avUserInfoData.speedBoatNameLower;
    if (baseUrl && baseUrl.trim() !== "" &&
      sBoat && sBoat.trim() !== ""
    ) {
      _url = baseUrl + sBoat
    }
    console.log('_url', _url)
    return _url
  }


  static getTermsAndConditionURL() {
    return HCLDX.get_REACT_APP_HCL_DX_BASE_URL() + "americas/about-avnet/terms-and-conditions-of-sale/";
  }

  static getTermsOfUse() {
    return HCLDX.get_REACT_APP_HCL_DX_BASE_URL() + "americas/about-avnet/legal/";
  }

  static getPrivacyURL() {
    return HCLDX.get_REACT_APP_HCL_DX_BASE_URL() + "americas/about-avnet/privacy";
  }

  static getHelpURL() {
    return HCLDX.get_REACT_APP_HCL_DX_BASE_URL() + "americas/about-avnet/help";
  }

  static getSOATerms() {
    return 'https://www.avnet.com/wps/portal/us/about-avnet/legal/'
  }

  static getTierParam() {
    return process.env.REACT_APP_TIER_PARAM
  }

  static getPaymetricURL() {
    return process.env.REACT_APP_PAYMETRIC_URL;
  }

  static isCallFromQuoteCart = () => {
    const currentUrl = window.location.pathname;
    const c = this.getParams();
    const cart = currentUrl.includes("shop")
    if (cart && c.quote_number !== undefined) {
      return true
    }
    return false
  }

  static getRedirectionURL = (url) => {
    let _url = "";
    const baseUrl = HCLDX.get_REACT_APP_HCL_DX_BASE_URL();
    const sBoat = Helper.toLowerCase(this.avUserInfoData.speedBoatName);
    if (baseUrl && baseUrl.trim() !== "" &&
      sBoat && sBoat.trim() !== "" &&
      url !== ""
    ) {
      // Check Speedboat URL and this works for NPI and other content tabs
      if (url.includes(sBoat)) {
        const splitUrlArr = url.split(sBoat);
        if (splitUrlArr && splitUrlArr.length > 0) {
          url = splitUrlArr[1];
        }
      }
      _url = baseUrl + sBoat + url;
    }
    return _url;
  };

  static getCurrencyFormat(currencyType) {
    const format = {
      'CHF': 'nb-NB',
      'CZK': 'nb-NB',
      'DKK': 'nb-NB',
      'EUR': 'nl-NL',
      'GBP': 'en-GB',
      'HKD': 'zh-HK',
      'ILS': 'nb-NB',
      'JPY': 'ja-JP',
      'NOK': 'nb-NB',
      'PLN': 'nb-NB',
      'RON': 'rof',
      'SEK': 'nb-NB',
      'TRY': 'tr-TR',
      'ZAR': 'en-ZA'
    };

    return format[currencyType] ? format[currencyType] : 'en-US'
  }

  static isCallFromCart = () => {
    const currentUrl = window.location.pathname;
    const cart = currentUrl.includes("shop")
    if (cart) {
      return true
    }
    return false
  }

  static checkIsCustomerPrice = (priceList) => {
    if (priceList && priceList[0] && (priceList[0].isCustomerSpecificPrice === true || priceList[0].priceSource.toUpperCase() === PriceType.YARS)) {
      return true;
    }
    return false
  }

  static checkIsEnableQuantity = (priceList) => {
    // if (!priceList[0] || priceList[0]?.isCustomerSpecificPrice === true || priceList[0]?.priceSource.toUpperCase() === PriceType.YARS || priceList[0]?.priceSource.toUpperCase() === PriceType.ZREC) {
    if (priceList[0]?.isCustomerSpecificPrice === true || priceList[0]?.priceSource.toUpperCase() === PriceType.YARS || priceList[0]?.priceSource.toUpperCase() === PriceType.ZREC) {
      return false
    }
    return true
  }

  static validateDomain = (email) => {
    if (!email) {
      return false;
    }
    if (email.includes('@')) {
      const userDomain = (email.split("@"))[1];
      const domains = Constants.internalUsers
      return domains.some(domain => domain.toLowerCase() === userDomain?.toLowerCase());
    } else {
      return true
    }
  }

  static monitorJSDx = () => {
    if (process.env.REACT_APP_REMOVE_HCLDX_INCLUDED_ASSETS === 'yes') {
      window.BOOMR?.plugins?.SPA?.wait_complete();
      console.log("stop BOOMR.plugins.SPA.wait_complete()");
    }
  }

  static monitorFrameWorkReady = () => {
    if (process.env.REACT_APP_REMOVE_HCLDX_INCLUDED_ASSETS === 'yes' && BOOMR?.plugins?.Continuity) {
      BOOMR.plugins.Continuity.frameworkReady();
      console.log("stop BOOMR.plugins.Continuity.frameworkReady()");
    }
  }

  static setEvars = (itemsId = '', eventStr = '', source = '', name = '', bomId = '') => {
    if (window?.digitalData) {
      if (!window?.digitalData?.transaction) {
        window.digitalData.transaction = {}
      }
      if (eventStr) {
        window.digitalData.event.eventinfo.events = eventStr;
      }
      if (itemsId) {
        window.digitalData.transaction.items = itemsId;
      }
      if (source) {
        window.digitalData.transaction.bomSource = source;
      }
      if (name) {
        window.digitalData.transaction.bomName = name;
      }
      if (bomId) {
        window.digitalData.transaction.bomId = bomId;
      }
    }
  }

  static getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
  }

  static getFormatNumber(params) {
    const { amount, currency = window.mct, symbol = "", maximumFractionDigits = 5, isSymbol = true, isDisplaySymbol = true } = params;
    const ROLCurr = currency === 'ROL' ? 'RON' : currency;
    const curSymbol = symbol ? symbol : getSymbolFromCurrency(ROLCurr)

    if (amount && isNumber(amount) && currency) {
      const formatAmount = new Intl.NumberFormat(this.getCurrencyFormat(currency), {
        style: 'currency',
        maximumFractionDigits: maximumFractionDigits,
        currency: currency,
        currencyDisplay: "code"
      }).format(amount).replace(currency, "").trim()

      /** 10807  Currency having same symbol ex: CHF those symbol will replace and single symbol we'll display - Pankaj - 28 April 2023 */
      if ((!isSymbol || !isDisplaySymbol) && formatAmount.includes(currency)) {
        return formatAmount.replace(currency, '')
      }
      return isSymbol ? curSymbol + formatAmount : formatAmount
    }
  }

  static getUserAddressType(params, addressId = null) { // Pass shipping address array into params
    const { WEB } = Constants.siteUser
    let { currentShipTo, defaultShipTo } = this.avUserInfoData

    if (this.avUserInfoData?.currentUser === WEB) {
      currentShipTo = addressId;
    }
    const { CountryCode: { US, CA }, Type: { DOMESTIC, INTERNATIONAL, CANADA } } = Constants.shippingAddressType

    const currentShippingAddressId = currentShipTo ? currentShipTo : defaultShipTo;
    let shippingType = INTERNATIONAL // Default address type is international
    let shippingAddressValue;

    if (params?.length > 0) {
      shippingAddressValue = params.find(val => val?.id === currentShippingAddressId);
    }

    if (shippingAddressValue?.address?.countryCode === US) {
      shippingType = DOMESTIC
    } else if (shippingAddressValue?.address?.countryCode === CA) {
      shippingType = CANADA
    } else {
      shippingType = INTERNATIONAL
    }

    return {
      shippingType: shippingType,
      shippingAddressValue: shippingAddressValue
    }
  }

  static getAddressTypeFromCountryCode(CountryCode) { // Pass shipping address array into params
    const { CountryCode: { US, CA }, Type: { DOMESTIC, INTERNATIONAL, CANADA } } = Constants.shippingAddressType;

    if (CountryCode === US) {
      return DOMESTIC
    } else if (CountryCode === CA) {
      return CANADA
    } else {
      return INTERNATIONAL
    }
  }
  static getUserShippingAddress() {
    let { currentShipTo, defaultShipTo } = this.avUserInfoData
    const currentShippingAddressId = currentShipTo ? currentShipTo : defaultShipTo;
    return currentShippingAddressId
  }

  static isSpecialOfferPkg(pkg) {
    let result = pkg === "BKN" || pkg === "BLK" || pkg === "BOX" || pkg === "LIT" || pkg === "RAL" || pkg === "SVC" || pkg === "TRY" || pkg === "UKN" || pkg === "VIR" ? true : false;
    return result;

  }

  static isCPNAvailableInList = (single_product, selectedCPN) => {
    if (single_product?.CustomerPartNumbers?.length > 0 && single_product?.CustomerPartNumbers.filter(e => e.CPN === selectedCPN).length > 0) {
      return true;
    }
    return false;
  }

  static checkSpecialOffer = (single_product, single_product_inventory) => {
    let pkg = single_product?.PackagingTypeCode;
    let stock = single_product_inventory?.inventoryQty;
    let isSpecialOffer = (single_product?.isAvnetDistributor && stock > 0) && (stock < single_product?.QtyMin)
    if (isSpecialOffer) {
      return {
        isSpecialOffer: isSpecialOffer,
        minQty: (single_product_inventory?.inventoryQty < single_product?.QtyMult) ? 1 : single_product?.QtyMult,
        multQty: (System.isSpecialOfferPkg(pkg) || single_product_inventory?.inventoryQty < single_product?.QtyMult) ? 1 : single_product?.QtyMult
      }
    } else {
      return {
        isSpecialOffer: isSpecialOffer
      }
    }

  }

  static checkValidQuantity = (single_product, single_product_inventory, qty) => {
    let res = false;

    let specialOffer = this.checkSpecialOffer(single_product, single_product_inventory)
    let isSpecialOffer = specialOffer?.isSpecialOffer
    let minQty = isSpecialOffer ? specialOffer?.minQty : single_product?.QtyMin;
    let multQty = isSpecialOffer ? specialOffer?.multQty : single_product?.QtyMult

    if (specialOffer) {
      let min = (qty > single_product_inventory?.inventoryQty) ? single_product?.QtyMin : minQty
      let mult = (qty > single_product_inventory?.inventoryQty) ? single_product?.QtyMult : multQty

      if (min !== minQty) {
        minQty = min
      }
      if (mult !== multQty) {
        multQty = mult
      }
    }


    if (qty >= 0 && qty !== "") {
      if (minQty < multQty && qty % minQty !== 0) {
        res = true;
      }
      else if (minQty && qty < minQty) {
        res = true;
      }
      else if (multQty && qty % multQty !== 0) {
        res = true;
      }
    }

    return res;
  };

  static xiPayIFrameLink(data) {
    return data ? `${System.getPaymetricURL()}/diecomm/View/Iframe/${data.guid}/${data.token}/True/` : ''
  }

  static xiPaytScript = `${System.getPaymetricURL()}/DIeComm/Scripts/XIFrame/XIFrame-1.2.0.js`;

  static getFieldType = (field) => {
    const config = Constants.CognitiveSearchFieldConfig;
    return config[field] || config.attributes;
  };

  static getFarnellCMPUrl() {
    return 'ABACUS-AVNET-BOM-DESIGNHUB-FARNELL';
  }
  static getCurrentCartCount = () => {
    return Cookies.get(System.storageName.CART_COUNT) ? Cookies.get(System.storageName.CART_COUNT) : 0;
  };

  static checkPriceValues = (pricingList) => {
    let isPriceVal = Object.keys(pricingList).length;
    let userAcctVal = (window?.avUserInfoJS) && JSON.parse(window?.avUserInfoJS);
    let avUserAccObj = userAcctVal?.account;
    if (avUserAccObj && Object.keys(avUserAccObj).length && isPriceVal) {
      return true;
    }
    else if (!avUserAccObj) {
      return true;
    }
  }

  static daysToWeeksAndDays = (days) => {
    const weeks = Math.floor(days / 7);
    const remainingDays = days % 7;
    return `${weeks + (weeks === 1 ? ' Week' : ' Weeks')} ${remainingDays ? remainingDays + (remainingDays === 1 ? ' Day' : ' Days') : ''}`;
  };
  static creditLineURL = 'https://www.avnet.com/fsp/opasdata/docs/AvnetCreditApplication.pdf'
}

export default System;
